<template>
  <div>
    <portal-target name="dropdown" slim />
    <div class="flex flex-col">
      <div class="h-screen flex flex-col" @click="hideDropdownMenus">
        <div class="md:flex flex-shrink-0">
          <div class="bg-sidebar-dark md:flex-shrink-0 md:w-40 px-6 py-4 flex items-center justify-between md:justify-center">
            <inertia-link class="mt-1" href="/">
              <logo class="fill-white" width="120" height="28" />
            </inertia-link>
          </div>
          <div class="bg-white border-b w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center">
            <div class="mt-1 mr-4"></div>
            <dropdown class="mt-1 z-20" placement="bottom-end">
              <div class="flex items-center cursor-pointer select-none group">
                <div class="text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 mr-1 whitespace-nowrap">
                  <span>{{ $page.props.auth.user.first_name }}</span>
                  <span class="hidden md:inline">{{ $page.props.auth.user.last_name }}</span>
                </div>
                <icon class="w-5 h-5 group-hover:fill-indigo-600 fill-gray-700 focus:fill-indigo-600" name="cheveron-down" />
              </div>
              <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link class="block px-6 py-2 hover:bg-primary-800-500 hover:text-white w-full" :href="route('customer.logout')" as="button" method="post">Logout</inertia-link>
              </div>
            </dropdown>
          </div>
        </div>
        <div class="flex flex-grow overflow-hidden">
          <div class="flex-1 px-4 py-8 overflow-y-auto" scroll-region>
            <div class="flex justify-around">
              <flash-messages />
            </div>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Dropdown from '@/Shared/Dropdown'
  import FlashMessages from '@/Shared/FlashMessages'
  import Icon from '@/Shared/Icon'
  import Logo from '@/Shared/Logo'

  export default {
    components: {
      Dropdown,
      FlashMessages,
      Icon,
      Logo
    },
    data() {
      return {
        showUserMenu: false
      }
    },
    methods: {
      url() {
        return location.pathname.substr(1)
      },
      hideDropdownMenus() {
        this.showUserMenu = false
      },
    },
  }
</script>

